<template>
    <g>
        <path
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
            :stroke="iconFill"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M6 6H6.00667" :stroke="iconFill" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6H10.0067" :stroke="iconFill" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M10.6673 8.66666H5.33398M5.33398 8.66666C5.33398 9.3739 5.61494 10.0522 6.11503 10.5523C6.61513 11.0524 7.29341 11.3333 8.00065 11.3333C8.7079 11.3333 9.38617 11.0524 9.88627 10.5523C10.3864 10.0522 10.6673 9.3739 10.6673 8.66666H5.33398Z"
            :stroke="iconFill"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</template>
<script>
export default {
    name: "MoodHappy1616",
    props: {
        iconFill: {
            type: String,
            default: "#C8D0DD",
        },
    },
};
</script>
